import React, { useImperativeHandle, useRef, useState, useEffect } from "react";
import Form, { ButtonItem, GroupItem, FormRef, Item, Label } from 'devextreme-react/form';
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { apiConfiguration } from "../../apiConfig";
import { ClickEvent } from 'devextreme/ui/button';
import { showError } from '../../utils/errorHandling';
import { ClientiApi } from "../../data";
import 'devextreme-react/text-area';
import { useTranslation } from 'react-i18next';
import './popupEditCustomer.scss';

import {
  Validator,
  RequiredRule,
  EmailRule,
  AsyncRule
} from 'devextreme-react/validator';


type Props = {
  onChange: () => void
}

export type EditCustomerPopupHandle = {
  edit: (idCliente: string) => void,
  new: () => void,
}

type state = {
  idCliente: string | undefined,
  visible: boolean,
  isUpdate: boolean,
  isInsert: boolean
}

const PopupEditCustomer: React.ForwardRefRenderFunction<EditCustomerPopupHandle, Props> = (props, ref) => {
  const [state, setState] = useState<state>({ idCliente: "", visible: false, isUpdate: false, isInsert: false });
  const formRef = useRef<FormRef>(null);
  const [formData, setFormData] = useState<any>();
  const { t } = useTranslation();

  function hideInfo() {
    setState({ idCliente: "", visible: false, isUpdate: false, isInsert: false });
  }

  useImperativeHandle(ref, () => ({
    edit(idCliente) {
      setState({ idCliente: idCliente, visible: true, isUpdate: true, isInsert: false });
    },
    new() {
      setState({ idCliente: undefined, visible: true, isUpdate: false, isInsert: true });
    }
  }));

  useEffect(() => {
    setFormData(null);
    if (state.idCliente) {
      const api = new ClientiApi(apiConfiguration);
      api.getClienteById({ idCliente: state.idCliente })
        .catch(showError)
        .then(function (data) {
          if (data) {
            setFormData(data);
          }
        })
    }

  }, [state.idCliente]);

  function check_piva(e: ClickEvent) {
    var validate = formRef.current?.instance().validate();
    if (validate?.isValid) {
      const api = new ClientiApi(apiConfiguration);
      var data = formRef.current?.instance().option("formData");
      var myid = "";

      if (data.partitaIva) {
        api.insertCliente({ clienteCreateDTO: data })
          .catch(showError)
          .then(function (data) {
            if (data) {
              myid = (data.id != null ? data.id.toString() : "");
              setFormData(data);
              props.onChange();
            }
          })
          .finally(() => setState({ idCliente: myid, visible: true, isUpdate: true, isInsert: false }));
      }
    }
  }

  function save_click(e: ClickEvent) {
    var validate = formRef.current?.instance().validate();

    if (validate?.isValid) {
      const api = new ClientiApi(apiConfiguration);
      var data = formRef.current?.instance().option("formData");

      if (state.idCliente) {
        api.updateCliente({
          idCliente: state.idCliente,
          clienteUpdateDTO: data
        })
          .catch(showError)
          .then(() => {
            props.onChange();
          })
          .finally(() => hideInfo());
      }
    }
  }

  function onFieldDataChanged(e: FieldDataChangedEvent) {
    // if (e.dataField === "dataDocumento" && e.component.getEditor('dataOperazione')?.option('value') == null) {
    //   e.component.updateData("dataOperazione", e.value);
    // }
  }

  return (<React.Fragment>
    <Popup
      visible={state.visible}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={false}
      fullScreen={false}
      showTitle={true}
      onHidden={hideInfo}
      // title={state.idCliente ? "Modifica cliente" : "Nuovo cliente"}
      container=".dx-viewport"
      height={"90%"}
    >
      <Position
        at="center"
        my="center"
        of=""
        collision="fit"
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="center"
        options={{
          text: t('chiudi'),
          onClick: hideInfo,
        }}
      />

      <Form id="form" ref={formRef} colCount={1} formData={formData} onFieldDataChanged={onFieldDataChanged} labelMode='floating'>
        <GroupItem caption={t ('daticliente')} visible={state.isUpdate} colCount={3} >
          <Item dataField="telefono" isRequired={true}>
            <Label text={t ('telefono')} />
          </Item>
          <Item dataField="mobile" isRequired={true}>
            <Label text={t ('mobile')}/>  
          </Item>        
          <Item
            dataField={'email'}
            editorType={'dxTextBox'}
            isRequired={true}
          >
            <Label text={t ('email')}/>           
            <EmailRule message="Email is invalid" />           
          </Item>
          <Item dataField="ragioneSociale" disabled={true} >
            <Label text={t ('ragioneSociale')}/> 
          </Item>
          <Item dataField="codiceFiscale" disabled={true}>
            <Label text={t ('codiceFiscale')}/> 
          </Item>
          <Item dataField="indirizzo" disabled={true} >
            <Label text={t ('indirizzo')}/> 
          </Item>
          <Item dataField="cap" disabled={true}>
            <Label text={t ('cap')}/> 
          </Item>
          <Item dataField="citta" disabled={true} >
            <Label text={t ('citta')}/> 
          </Item>
          <Item dataField="provinciaCodice" disabled={true} >
            <Label text={t ('provinciaCodice')}/> 
          </Item>
          <Item dataField="provinciaDescrizione" disabled={true} >
            <Label text={t ('provinciaDescrizione')}/> 
          </Item>
          <Item dataField="nazioneCodice" disabled={true} >
            <Label text={t ('nazioneCodice')}/> 
          </Item>
          <Item dataField="nazioneDescrizione" disabled={true} >
            <Label text={t ('nazioneDescrizione')}/> 
          </Item>
          <Item dataField="pec" disabled={true} >
            <Label text={t ('pec')}/> 
          </Item>
          <Item dataField="codiceUnicocoSDI" disabled={true} >
            <Label text={t ('codiceUnicocoSDI')}/> 
          </Item>
          <Item dataField="formaGiuridicaId" disabled={true} >
            <Label text={t ('formaGiuridicaId')}/> 
          </Item>
          <Item dataField="formaGiuridicaDescrizione" disabled={true} >
            <Label text={t ('formaGiuridicaDescrizione')}/> 
          </Item>
          <Item dataField="pagmentoCodice" disabled={true} >
            <Label text={t ('pagmentoCodice')}/> 
          </Item>
          <Item dataField="pagmentoDescrizione" disabled={true} >
            <Label text={t ('pagmentoDescrizione')}/> 
          </Item>
          <Item dataField="listinoCodice" disabled={true} visible={false}/>
          <Item dataField="listinoDescrizione" disabled={true} >
            <Label text={t ('listinoDescrizione')}/> 
          </Item>
          <Item dataField="affidabilitaPunteggio" disabled={true} >
          <Label text={t ('affidabilitaPunteggio')}/> 
          </Item>
          <Item dataField="importoMinimoOrdine" disabled={true} >
            <Label text={t ('importoMinimoOrdine')}/> 
          </Item>
          <ButtonItem
            colSpan={3} 
            cssClass="centered-button"
            buttonOptions={{
              text: t('salva'),
              type: 'success',
              width: '300px',
              onClick: save_click,
              visible: state.isUpdate
            }}
          />
        </GroupItem>

        <GroupItem caption={t ('ricercaPIva')} visible={state.isInsert} colCount={3} >
          <Item dataField="partitaIva" isRequired={true} >
            <Label text={t ('partitaIva')}/>
          </Item>
          <ButtonItem
            buttonOptions={{
              text: t ('verificacaPIva'),
              type: 'normal',
              width: '300px',
              onClick: check_piva
            }}
          />
        </GroupItem>
      </Form>




      {/* <EditCustomer idCliente={state.idCliente != null ? state.idCliente.toString() : ""} onChanged={() => {setIsChanged(true); hideInfo()}} /> */}






    </Popup>
  </React.Fragment>
  );
}

export default React.forwardRef(PopupEditCustomer);
